/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import { ErrorMessage, Form, Formik } from 'formik'
import { login } from '../core/_requests'
import { useAuth } from '../core/Auth'
import InputComponent from '../../../../_metronic/layout/components/InputComponent'
import { useIntl } from 'react-intl'
import { toast } from 'react-toastify'
import { HeaderLanguage } from '../../../../_metronic/partials'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'
import { useLang } from '../../../../_metronic/i18n/Metronici18n'
import { MenuComponent } from '../../../../_metronic/assets/ts/components'
import ReCAPTCHA from 'react-google-recaptcha'
import { error } from 'console'

const initialValues = {
  email: '',
  password: '',
  recaptcha_value: '',
}
const languages = [
  {
    lang: 'tr',
    name: 'Türkçe',
    flag: toAbsoluteUrl('/media/flags/turkey.svg'),
  },
  {
    lang: 'en',
    name: 'English',
    flag: toAbsoluteUrl('/media/flags/united-states.svg'),
  },
  {
    lang: 'ar',
    name: 'Arabic',
    flag: toAbsoluteUrl('/media/flags/united-states.svg'),
  },
]

/*
  Formik+YUP+Typescript:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
  https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function Login() {
  // Reinit yapmazsak language select butonu çalışmıyor.
  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  // Dil
  const intl = useIntl()
  const t = (id: any, values = {}) => intl.formatMessage({ id }, values)

  const loginSchema = Yup.object().shape({
    email: Yup.string()
      .email(t('email_valid_alert'))
      .min(3, 'Minimum 3 symbols')
      .max(50, 'Maximum 50 symbols')
      .required(t('email_required')),
    password: Yup.string()
      .min(3, 'Minimum 3 symbols')
      .max(50, 'Maximum 50 symbols')
      .required(t('password_required')),
    recaptcha_value: Yup.string().required(t('required_field_alert')),
  })


  const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
    toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px'

  const [loading, setLoading] = useState(false)
  const { saveAuth, setCurrentUser } = useAuth()

  const lang = useLang()
  const currentLanguage = languages.find((x) => x.lang === lang)

  const recaptchaChange = (value: string | null, values: any) => {
    values.recaptcha_value = value || ''

  }


  return (
    <Formik
      initialValues={initialValues}
      validationSchema={loginSchema}
      onSubmit={async (values) => {
        console.log('Form verileri gönderiliyor:', values);
        setLoading(true)
        try {

          const { data: auth } = await login(values.email, values.password, values.recaptcha_value)
          if (auth.is_redirect === true) {
            window.location.replace(auth.server_url)
          } else {
            // Expire date için
            const currentDate = new Date()
            currentDate.setHours(currentDate.getHours() + 3)
            currentDate.setMinutes(currentDate.getMinutes() + 50)
            // Tarih formatını ayarlamak için toLocaleString kullanın
            const formattedDate = currentDate.toLocaleString('en-US', {
              year: 'numeric',
              month: 'short',
              day: '2-digit',
              hour: '2-digit',
              minute: '2-digit',
              second: '2-digit',
              hour12: false,
            })
            const formattedAuth = { ...auth, expire: formattedDate }
            saveAuth(formattedAuth)
            const user = localStorage.getItem('kt-auth-react-v')
            if (user) {
              const userJSON = JSON.parse(user)
              const { data } = userJSON
              if (data) {
                setCurrentUser(data)
              } else {
                setLoading(false)
                const errors: any = auth
                errors.validator_errors &&
                  Object.keys(errors.validator_errors).forEach((key) => {
                    const errorsForField = errors.validator_errors[key]
                    errorsForField.forEach((error: any) => {
                      toast.error(error)
                    })
                  })
              }
            }
          }
        } catch (error) {
          console.error('error', error)
          saveAuth(undefined)
          setLoading(false)
        }
      }}
    >
      {({ values, errors, touched }) => (
        <Form className='form w-100' noValidate id='kt_login_signin_form'>
          {/* begin::Heading */}
          <div className='text-center mb-4'>
            <h1>{t('netway_management_panel')}</h1>
          </div>
          {/* begin::Language */}
          <div
            className={clsx(
              'd-flex align-items-center justify-content-end',
              toolbarButtonMarginClass
            )}
            style={{ top: '1rem', right: '1rem' }}
            id='kt_header_user_menu_toggle'
          >
            {/* begin::Toggle */}
            <div
              className={clsx(
                'cursor-pointer symbol bg-secondary w-100px mb-4 bg-opacity-25 btn btn-icon btn-active-light-primary btn-custom',
                toolbarUserAvatarHeightClass
              )}
              data-kt-menu-trigger='click'
              data-kt-menu-attach='parent'
              data-kt-menu-placement='bottom-end'
              data-kt-menu-flip='bottom'
            >
              {currentLanguage?.name}
            </div>
            <HeaderLanguage />
            {/* end::Toggle */}
          </div>
          {/* end::language */}
          {/* begin::Form group */}
          <div className='fv-row mb-4'>
            <InputComponent
              label={t('email')}
              col={`col-12`}
              controlId='floatingEmail'
              type='email'
              name='email'
              isAutoComplete='on'
            />
          </div>
          {/* end::Form group */}

          {/* begin::Form group */}
          <div className='fv-row mb-8 '>
            <InputComponent
              label={t('password')}
              col={`col-12`}
              controlId='floatingPassword'
              type='password'
              name='password'
              isAutoComplete='on'
            />
          </div>
          {/* end::Form group */}
          <ReCAPTCHA
            sitekey='6LcxZTohAAAAADca-nZXaBEkLX0-OL1MTMlImV8X'
            size='normal'
            onChange={(value) => recaptchaChange(value, values)}
          />
          {/* begin::Action */}
          {errors.recaptcha_value && touched.recaptcha_value && (
            <div className='mt-2 alert alert-danger'>
              <div className='alert-text font-weight-bold'>{errors.recaptcha_value}</div>
            </div>
          )}
          <div className=' pb-4 mt-10'>
            <div className='text-center'>
              <button
                type='submit'
                id='kt_sign_in_submit'
                className={`btn btn-primary w-100 py-4`}
                disabled={loading}
              >
                {!loading && <span className='indicator-label'>{t('continue')}</span>}
                {loading && (
                  <span className='indicator-progress' style={{ display: 'block' }}>
                    {t('please_wait')}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
            </div>
          </div>
          <div className='d-flex'>
            <div className='d-flex w-100 mt-4'>
              {/* begin::Link */}
              <Link
                to='/auth/forgot-password'
                className='link-primary fs-6 fw-bolder'
                style={{ marginLeft: '5px' }}
              >
                {t('forgot_password')}
              </Link>
              {/* end::Link */}
            </div>
          </div>
        </Form>
      )}
    </Formik>
  )
}
